module.exports = __webpack_public_path__ + "static/media/filmm2021.55d71f34.png";